import React, { useState, useEffect, useContext } from "react";
import * as APICalls from "./JsFiles/APICalls";
import * as wordAPI from "./JsFiles/WordAPI";
import { ConvertXMLtoHTML } from "./LawChanges";
import {
  workItemObjectContext,
  decodedTokenObjectContext,
  userInfoObjectContext,
  accessesObjectContext,
  messageBoxContext,
  errorBoxContext,
} from "./App";

import "../style/lawPage.css";
import minusyellow from "./../../../assets/images/minusyellow.png";
import minusblue from "./../../../assets/images/minusblue.png";
import minusgrey from "./../../../assets/images/minusgrey.png";
import plusyellow from "./../../../assets/images/plusyellow.png";
import plusblue from "./../../../assets/images/plusblue.png";
import plusgrey from "./../../../assets/images/plusgrey.png";

var lastClickEvent = Date.now();
var isNoteIdApiInitiated = false;

export default function LawPage() {
  const [workItemObject, setWorkItemObject] = useContext(workItemObjectContext);
  const [decodedTokenObject, setDecodedTokenObject] = useContext(decodedTokenObjectContext);
  const [userInfoObject, setUserInfoObject] = useContext(userInfoObjectContext);
  const [accessesObject, setAccessesObject] = useContext(accessesObjectContext);
  let setMessageBoxProp = useContext(messageBoxContext);
  let setErrorBoxProp = useContext(errorBoxContext);
  const [wordTagsArray, setWordTagsArray] = useState([]);
  const [newClickEvent, setNewClickEvent] = useState(Date.now());
  const [changesSummaries, setChangesSummaries] = useState(false);

  var ExistingNotesForNoteId = [];
  var neighbourElementsArray = [];
  var badChars = [" ", ",", ".", "!", ":", ";", "(", ")", '"', "'", "[", "]"];
  var initialLawText;
  var subIds = makesubIdsArray();

  useEffect(() => {
    try {
      makesubIdsArray();
      load().then(async () => {
        // temporary logging
        sendLog("INFO", workItemObject.Id + "  load() done.");
        await initiatingFirstTime();
      });
    } catch (err) {
      console.log("problem with loading page", err);
      handleActionOfErrorBox("loadingFail");
      sendLog("ERROR", "Error loading notes to add-on");
    }
  }, []);

  useEffect(() => {
    const sinceLastClickEventInMs = newClickEvent - lastClickEvent;
    // 4 hours
    if (sinceLastClickEventInMs > 4 * 60 * 60 * 1000) {
      handleActionOfErrorBox("inactivity");
    }
    lastClickEvent = newClickEvent;
  }, [newClickEvent]);

  const load = async () => {
    try {
      await loadLawFromServer();
      await extractTagsArray();
      // temporary logging
      sendLog("INFO", workItemObject.Id + "  extractTagsArray() done.");
      await addKarnovTools();
      // temporary logging
      sendLog("INFO", workItemObject.Id + "  addKarnovTools() done.");
      await addNoteIdsToLawHtml();
      // temporary logging
      sendLog("INFO", workItemObject.Id + "  addNoteIdsToLawHtml() done.");
      await addChangesSummariesButtons();
    } catch (err) {
      console.log("problem with loading page", err);
      handleActionOfErrorBox("loadingFail");
      sendLog("ERROR", "Error loading notes to add-on");
    }
  };

  function makesubIdsArray() {
    let subIdLenght = 0;
    if (workItemObject.SubIds) {
      subIdLenght = workItemObject.SubIds.length;
    }

    let result = [];
    for (let index = 0; index < subIdLenght; index++) {
      const element = workItemObject.SubIds[index];
      result.push(element.SubId);
    }
    return result;
  }

  const loadLawFromServer = async () => {
    if (!initialLawText) {
      await APICalls.getLawText(userInfoObject, workItemObject, decodedTokenObject)
        .then((lawText) => {
          document.getElementById("lovtekst").innerHTML = lawText;
          initialLawText = lawText;
        })
        .catch(() => {
          sendLog("ERROR", "Error getting law html from backend");
          handleActionOfErrorBox("gettingDocumentFail");
        });
    } else {
      document.getElementById("lovtekst").innerHTML = initialLawText;
    }
  };

  const initiatingFirstTime = async () => {
    try {
      initiatingEventListeners();
    } catch (err) {
      console.log("problem with initiating event listeners", err);
      sendLog(
        "ERROR",
        workItemObject.Id +
          "  initiatingEventListeners() failed. CanAddNotes: " +
          accessesObject.CanAddNotes.toString(),
        "initiatingEventListeners",
        err?.message
      );
    }

    if (accessesObject.CanAddNotes == true) {
      // temporary logging
      sendLog("INFO", workItemObject.Id + "  just right before initiatingNoteId() done.");
      await initiatingNoteId();
    }
    goToFirstRelevantParagraphOnLoad();
  };

  const initiatingNoteId = async () => {
    // temporary logging
    sendLog("INFO", "NoteIds Object sent to NoteId service", "", JSON.stringify(ExistingNotesForNoteId));

    await APICalls.initNoteIds(ExistingNotesForNoteId, userInfoObject, workItemObject, decodedTokenObject)
      .then((result) => {
        // temporary logging
        sendLog("INFO", "response from NoteId service", "", JSON.stringify(result));

        applyingPersistedNotes(result);
      })
      .catch(async (e) => {
        // Run the second try
        await APICalls.initNoteIds(ExistingNotesForNoteId, userInfoObject, workItemObject, decodedTokenObject)
          .then((result) => {
            // temporary logging
            sendLog("INFO", "response from NoteId service", "", JSON.stringify(result));

            applyingPersistedNotes(result);
          })
          .catch((e) => {
            sendLog("ERROR", "Error initiating noteId service");
            console.log("Error initiating noteId service", e);
            handleActionOfErrorBox("initiatingNoteIdFail");
          });
      });
  };

  const applyingPersistedNotes = (response) => {
    response.PersistedNotes.forEach((notesInSection) => {
      let querySelectorStr = `div#lovtekst section[data-sl-semanticpath=${CSS.escape(notesInSection.ContainerId)}]`;
      let noteSectionId;
      let elem = document.querySelector(querySelectorStr);
      if (elem) {
        noteSectionId = elem.getAttribute("id");
        notesInSection.NoteIds.forEach((noteIdObj) => {
          wordTagsArray.forEach((tagElement) => {
            if (tagElement.sectionId == noteSectionId && tagElement.noteId == noteIdObj.Id) {
              tagElement.isPersisted = true;
            }
          });
        });
      } else {
        sendLog("ERROR", "Error finding semanticpath for this containerId: " + ContainerId);
        console.log("Error finding semanticpath for this containerId: " + ContainerId, error);
      }
    });
    isNoteIdApiInitiated = true;
  };

  const initiatingEventListeners = () => {
    // outside of if(canAddNote) because of navigating to note when double clicking on a textSelection note
    addEventListenerToElement("#lovtekst", "dblclick", checkRemoveTextSelectionButtons);
    addEventListenerToElement("#wholePage", "click", () => setNewClickEvent(Date.now()));

    if (accessesObject.CanAddNotes == true) {
      document.querySelectorAll(".removeTextSelectionButton").forEach((button) => {
        button.addEventListener("click", () => {
          const tag = button.getAttribute("tag");
          checkForRemovingPublishedNotes(tag);
        });
      });

      document.querySelectorAll(".addTextSelectionButton").forEach((button) => {
        button.addEventListener("click", () => addTextSelection(button));
      });

      addEventListenerToElement("#lovtekst", "mouseup", checkForAddTextSelectionButtons);

      addEventListenerToElement("#lovtekst", "mousedown", () => {
        window.getSelection().empty();
        hideModalElements();
      });

      addEventListenerToElement(".tabPart", "mousedown", () => {
        window.getSelection().empty();
        hideModalElements();
      });

      // The DocOps button is only rendered in Verktoy.js for DevOps users, so attaching
      // its listener must be skipped for everyone else.
      if (userInfoObject.IsKarnovDevOps == true) {
        attachDocOpsModeActivatorListener();
      }
    }
  };

  const addEventListenerToElement = (selector, eventName, handler) => {
    const element = document.querySelector(selector);
    if (!element) {
      sendLog(
        "WARNING",
        workItemObject.Id + "  initiatingEventListeners() could not find element: " + selector
      );
      return;
    }
    element.addEventListener(eventName, handler);
  };

  const attachDocOpsModeActivatorListener = () => {
    const attach = (button) =>
      button.addEventListener("click", () => {
        reloadAfterDeactivatingDocOpsMode();
      });

    const button = document.querySelector("button.docOpsModeActivator");
    if (button) {
      attach(button);
      return;
    }

    // Verktoy.js renders the button only after its user info requests have finished, which
    // can take up to a minute. Observe the DOM so the listener attaches whenever it appears.
    const observer = new MutationObserver(() => {
      const lateButton = document.querySelector("button.docOpsModeActivator");
      if (lateButton) {
        observer.disconnect();
        attach(lateButton);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const goToFirstRelevantParagraphOnLoad = () => {
    let FirstParagraph = document.querySelector("button.karnovToolsButton");
    // Documents without matching sections have no karnov tools buttons.
    if (!FirstParagraph) {
      return;
    }
    if (FirstParagraph.offsetTop > 500) {
      window.scrollTo(0, FirstParagraph.offsetTop - 150);
    }
  };

  // ----------------- start of KarnoveTools ------------------

  const addKarnovTools = async () => {
    let selectorAll = document.querySelectorAll(
      "div#lovtekst section[nodetype='paragraf'],div#lovtekst section[nodetype='article'],div#lovtekst section[nodetype='att'],div#lovtekst section[nodetype='ch'],div#lovtekst section[nodetype='part'], div#lovtekst div[nodetype='ledd'], div#lovtekst li[nodetype='point'], div#lovtekst li[nodetype='ledd']"
    );

    selectorAll.forEach((selected) => {
      const sectionId = parentSectionAttributeFinder(selected, "id");
      if (selected.nodeName == "SECTION") {
        addButtonsForSections(selected, sectionId);
      } else {
        // we dont want to have startnote for irregular items for examples vedlegger. this kind of items doesnot have phrase
        if (
          subIds.includes(sectionId) &&
          accessesObject.CanAddNotes &&
          checkForPhraseInElement(selected) &&
          (selected.nodeName == "DIV" || selected.nodeName == "LI")
        ) {
          addButtonsForDivAndLi(selected);
        }
      }
    });
  };

  const checkForPhraseInElement = (element) => (element.getAttribute("data-kw-phrase") ? true : false);

  const addButtonsForSections = (selected, sectionId) => {
    if (subIds.includes(sectionId)) {
      // selected.firstElementChild.style = "display:inline";
      let div = document.createElement("div");
      div.className = "karnovTools";
      selected.setAttribute("sectionDisable", "false");
      if (accessesObject.CanAddNotes == true) {
        div.appendChild(addNoteButton(selected));
      }
      div.appendChild(goToParagraphButton(selected));
      selected.prepend(div);
    } else {
      selected.setAttribute("sectionDisable", "true");
    }
  };

  const addButtonsForDivAndLi = (selected) => {
    let div = document.createElement("div");
    div.className = "karnovTools";
    div.appendChild(addNoteButton(selected));
    selected.prepend(div);
  };

  const karnovToolsButtonClicked = (event) => {
    let buttonElement = event.target;
    if (buttonElement.nodeName != "BUTTON") {
      buttonElement = buttonElement.parentNode;
    }
    // let buttonElement = element.nodeName == "BUTTON" ? element : element.parentNode;
    // let buttonElement = element.cloneNode(true);
    let sectionId = buttonElement.getAttribute("sectionId");

    if (buttonElement.classList.contains("goToParagraph")) {
      wordAPI.goToComment(sectionId);
    } else {
      let tag = buttonElement.getAttribute("tag");
      let containerId = buttonElement.getAttribute("containerId");
      if (buttonElement.classList.contains("addNote")) {
        let buttonId = buttonElement.getAttribute("id");
        let lastNoteId = findLastNoteId(sectionId, buttonId, 0, "starNote");
        let phrase = buttonElement.parentNode.parentNode.getAttribute("data-kw-phrase");
        let title = phrase;
        let addAfterTag = findAddAfterTag(lastNoteId, sectionId);
        // console.log("addAfterTag", addAfterTag);
        const docOpsMode = document.querySelector("#lawTab").classList.contains("docOpsMode");
        if (docOpsMode == false) {
          handleActionOfMessageBox("startAddingNote");
          APICalls.newNoteId(containerId, lastNoteId, userInfoObject, workItemObject, decodedTokenObject)
            .then((noteIdResponse) => {
              // console.log("noteIdResponse", noteIdResponse);
              wordAPI
                .addNoteFunc(tag, phrase, phrase, addAfterTag, sectionId, noteIdResponse.DisplayNewId)
                .then(() => {
                  reNumberingNotesForAddNote(
                    "starNote",
                    tag,
                    title,
                    sectionId,
                    containerId,
                    noteIdResponse,
                    "",
                    addAfterTag
                  )
                    .then(() => {
                      load().then(() => {
                        handleActionOfMessageBox("successAddingNote");
                        sendLog("INFO", "AddNote", "StarNote", tag);
                        sendMetric("AddNote", "StarNote", "Success", tag);
                      });
                    })
                    .catch((err) => {
                      console.log("problem with renumbering notes", err);
                      handleActionOfErrorBox("addingNoteFail");
                      sendLog("ERROR", "AddNote", "StarNote", tag + "problem with renumbering notes");
                    });
                })
                .catch((err) => {
                  console.log("adding comment box error", err);
                  handleActionOfErrorBox("addingNoteFail");
                  sendLog("ERROR", "AddNote", "StarNote", tag + "adding comment box error");
                });
            })
            .catch((err) => {
              console.log("note id servise error", err);
              handleActionOfErrorBox("addingNoteFail");
              sendLog("ERROR", "AddNote", "StarNote", tag + "note id servise error");
            });
        } else {
          document.querySelector(".docOpsModal").style.display = "block";
          let docOpsNewTagInfo = document.querySelector(".newTagInfoDocOpsMode");
          docOpsNewTagInfo.setAttribute("tag", tag);
          docOpsNewTagInfo.setAttribute("title", title);
          docOpsNewTagInfo.setAttribute("phrase", phrase);
          docOpsNewTagInfo.setAttribute("addAfterTag", addAfterTag);
          docOpsNewTagInfo.setAttribute("sectionId", sectionId);
          docOpsNewTagInfo.setAttribute("containerId", containerId);
          docOpsNewTagInfo.setAttribute("noteType", "starNote");
        }
      } else if (buttonElement.classList.contains("removeNote")) {
        const leftPosition = buttonElement.offsetLeft;
        const topPosition = buttonElement.offsetTop - 27;
        let levelOneButton = document.querySelector("#textSelectionRemove1");
        levelOneButton.style = `display:block; top: ${topPosition}px; left: ${leftPosition}px;`;
        levelOneButton.setAttribute("tag", tag);
        levelOneButton.setAttribute("sectionId", sectionId);
        levelOneButton.setAttribute("containerId", containerId);
        // levelOneButton.setAttribute("noteId", noteId);
        // checkForRemovingPublishedNotes(tag);
      }
    }
  };
  // ------------------ start of Static Elements ----------------

  const addNoteButton = (selected) => {
    const buttonElement = document.createElement("button");
    buttonElement.className = "karnovToolsButton addNote";
    let tag = selected.getAttribute("data-kw-tag");
    let sectionId = parentSectionAttributeFinder(selected, "id");
    let containerId = parentSectionAttributeFinder(selected, "data-sl-semanticpath");

    buttonElement.setAttribute("tag", tag);
    buttonElement.setAttribute("sectionId", sectionId);
    buttonElement.setAttribute("containerId", containerId);
    buttonElement.id = tag;
    buttonElement.setAttribute("group", "Note");
    const iconElement = document.createElement("i");
    iconElement.className = "bi bi-pencil";
    iconElement.setAttribute("style", "font-size: 12px; color: cornflowerblue;");
    buttonElement.prepend(iconElement);
    buttonElement.addEventListener("click", karnovToolsButtonClicked);
    return buttonElement;
  };

  const goToParagraphButton = (selected) => {
    const buttonElement = document.createElement("button");
    buttonElement.className = "karnovToolsButton goToParagraph";
    buttonElement.setAttribute("group", "goToParagraph");
    const sectionId = parentSectionAttributeFinder(selected, "id");
    buttonElement.setAttribute("sectionId", sectionId);
    const iconElement = document.createElement("i");
    iconElement.className = "bi bi-arrow-left";
    iconElement.setAttribute("style", "font-size: 12px; color: cornflowerblue;");
    buttonElement.prepend(iconElement);
    buttonElement.addEventListener("click", karnovToolsButtonClicked);
    return buttonElement;
  };

  // ------------------ end of Static Elements ----------------

  const parentSectionAttributeFinder = (element, attribute) => {
    let result = null;
    let counter = 0;
    while (!result && 30 > counter) {
      if (element.nodeName == "SECTION") {
        result = element.getAttribute(attribute);
      } else {
        if (element.parentNode) {
          element = element.parentNode;
        }
      }
      counter++;
    }
    return result;
  };

  const checkForRemovingPublishedNotes = (tag) => {
    let wordTagsArrayLength = wordTagsArray.length;
    let tagReached = false;
    for (let index = 0; index < wordTagsArrayLength && !tagReached; index++) {
      const element = wordTagsArray[index];
      if (tag == element.tag) {
        const noteId = element.noteId;
        const sectionId = element.sectionId;
        const containerId = element.containerId;
        tagReached = true;

        if (element.isPersisted == true) {
          document.querySelector(".removeModal").style = "display: block";
          let approveRemovebutton = document.querySelector("#removeModalButton");
          approveRemovebutton.setAttribute("tag", tag);
          approveRemovebutton.setAttribute("sectionId", sectionId);
          approveRemovebutton.setAttribute("containerId", containerId);
          approveRemovebutton.setAttribute("noteId", noteId);
        } else {
          removeNote(tag, sectionId, containerId, noteId);
        }
      }
    }
  };

  const removeNote = (tag, sectionId, containerId, noteId) => {
    handleActionOfMessageBox("startDeletingNote");
    hideModalElements();
    APICalls.removeNoteId(containerId, noteId, userInfoObject, workItemObject, decodedTokenObject)
      .then((noteIdResponse) => {
        wordAPI
          .removeNoteFunc(tag)
          .then(() => {
            reNumberingNotesForRemoveNote(tag, sectionId, noteIdResponse)
              .then(() => {
                load().then(() => {
                  handleActionOfMessageBox("successDeletingNote");
                  sendLog("INFO", "RemoveNote", "", tag);
                  sendMetric("RemoveNote", "", "Success", tag);
                });
              })
              .catch((err) => {
                handleActionOfErrorBox("removingNoteFail");
                // show error box
                console.log("problem with renumbering other tags ", err);
                sendLog("ERROR", "RemoveNote", "", tag + "  problem with renumbering other tags ");
              });
          })
          .catch((removeNoteFuncError) => {
            handleActionOfErrorBox("removingNoteFail");
            // show error box
            console.log("tags are not well constructed so word Api cannot remove that ", removeNoteFuncError);
            sendLog("ERROR", "RemoveNote", "", tag + "  container are not well constructed");
          });
      })
      .catch((noteIdServiceError) => {
        handleActionOfErrorBox("removingNoteFail");
        // show error box
        console.log("noteId Service Error", noteIdServiceError);
        sendLog("ERROR", "RemoveNote", "", tag + "  noteId Service Error");
      });
  };

  // ----------------- end of KarnoveTools ------------------

  // ----------------- start of loading and applying existing tags ------------------

  const extractTagsArray = async () => {
    if (isNoteIdApiInitiated == false) {
      try {
        ExistingNotesForNoteId = [];

        // empty the array
        wordTagsArray.length = 0;
        setWordTagsArray(wordTagsArray);
        return Word.run(async (context) => {
          let cc = context.document.body.contentControls;
          cc.load("tag, title, text");
          return context.sync().then(() => {
            //temporary logging
            try {
              let notes = cc.items.filter((x) => x.title && x.text.startsWith("Note "));
              let foo = [];
              notes.forEach((note) => {
                foo.push({ title: note.text, tag: note.tag });
              });
              sendLog("INFO", "Extracted notes title from word document (extractTagsArray)", "", JSON.stringify(foo));
            } catch (e) {
              const msg = `Couldnot Extracte notes title from word document. workitem: ` + workItemObject.Id;
              sendLog("WARNING", msg);
            }
            //end of temporary logging

            // Track physical section for misplacement detection.
            // cc.items are in document order — track which section each note physically resides in.
            const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            let currentPhysicalSection = null;

            cc.items.forEach((element) => {
              // Update physical section tracker when we encounter a section content control
              if (guidPattern.test(element.tag)) {
                currentPhysicalSection = element.tag;
              }

              if (element.title && element.text.startsWith("Note ")) {
                const colonIndex = element.text.indexOf(":");
                let noteIdNumber = element.text.slice(5, colonIndex);
                let noteId = "n" + noteIdNumber;
                if (element.tag.startsWith("starnote__")) {
                  let elem = document.querySelector(`[data-kw-tag=${CSS.escape(element.tag)}]`);
                  if (elem) {
                    const sectionId = parentSectionAttributeFinder(elem, "id");
                    const containerId = parentSectionAttributeFinder(elem, "data-sl-semanticpath");

                    // Warn if note is physically in a different section than HTML maps it to
                    if (currentPhysicalSection && sectionId && currentPhysicalSection !== sectionId) {
                      const msg = `Note "${element.tag}" is physically in section ${currentPhysicalSection} but HTML maps it to section ${sectionId}. Possible version mapping issue.`;
                      console.warn("KWord: " + msg);
                      sendLog("WARNING", msg);
                    }

                    wordTagsArray.push({
                      type: "starNote",
                      tag: element.tag,
                      title: element.title,
                      sectionId: sectionId,
                      containerId: containerId,
                      noteId: noteId,
                      isPersisted: false,
                    });
                    setWordTagsArray(wordTagsArray);
                    addToExistingNotesForNoteId(containerId, noteId);
                  } else {
                    const msg = `Couldnot find note with this tag:  ${element.tag}, in the law text with this workitemId: ${workItemObject.Id}`;
                    console.error("From KText: " + msg);
                    sendLog("WARNING", msg);
                  }
                } else {
                  const sectionId = element.tag.slice(0, 36);
                  let elem = document.querySelector(`[id=${CSS.escape(sectionId)}]`);
                  if (elem) {
                    let containerId = parentSectionAttributeFinder(elem, "data-sl-semanticpath");
                    let positionInSection = findPositionInSectionFromTitle(element.title);
                    let positionInSectionArray = positionInSection.split("__");
                    const startPosition = parseFloat(positionInSectionArray[0]);
                    const endPosition = parseFloat(positionInSectionArray[1]);
                    wordTagsArray.push({
                      type: "textSelection",
                      tag: element.tag,
                      title: element.title,
                      sectionId: sectionId,
                      containerId: containerId,
                      noteId: noteId,
                      isPersisted: false,
                      startPosition: startPosition,
                      endPosition: endPosition,
                    });
                    setWordTagsArray(wordTagsArray);
                    addToExistingNotesForNoteId(containerId, noteId);
                  } else {
                    const msg = `Couldnot find note with this tag:  ${sectionId}, in the law text with this workitemId: ${workItemObject.Id}`;
                    console.error("From KText: " + msg);
                    sendLog("WARNING", msg);
                  }
                }
              }
            });
          });
        });
      } catch (error) {
        console.error("Couldnot create WordTagsArray", error);
        sendLog("ERROR", "Couldnot create WordTagsArray", error, wordTagsArray);
      }
    }
  };

  const addNoteIdsToLawHtml = async () => {
    wordTagsArray.sort((a, b) => {
      if (
        a.type == "textSelection" &&
        b.type == "textSelection" &&
        a.sectionId == b.sectionId &&
        a.endPosition == b.endPosition
      ) {
        return b.startPosition - a.startPosition;
      } else if (a.type == "textSelection" && b.type == "textSelection" && a.sectionId == b.sectionId) {
        return a.endPosition - b.endPosition;
      }
    });

    setWordTagsArray(wordTagsArray);

    wordTagsArray.forEach((element) => {
      if (element.type == "starNote") {
        if (accessesObject.CanAddNotes == true && subIds.includes(element.sectionId)) {
          changeButtonsForExistingComments(element);
        }
      } else if (element.type == "textSelection") {
        let positionInSection = findPositionInSectionFromTitle(element.title);
        let foo = findingTheNodeToAddSelection(element);
        let pElement = foo[0];
        let newStartPosition = foo[1];
        let newEndPosition = foo[2];
        let listOfChildsInvolved = findChildsInvolvedInsideParagraph(pElement, newStartPosition, newEndPosition);
        if (listOfChildsInvolved.length == 2 && (listOfChildsInvolved[1].nodeName == "#text" || listOfChildsInvolved[1].nodeName == "EM")) {
          addCommentToPlainText(
            listOfChildsInvolved,
            newStartPosition,
            newEndPosition,
            element.tag,
            positionInSection,
            element.noteId
          );
        } else {
          addCommentToAnotherLayer(
            pElement,
            newStartPosition,
            newEndPosition,
            element.tag,
            positionInSection,
            element.noteId
          );
        }
      }
    });
  };

  const findPositionInSectionFromTitle = (title) => {
    const doubleUnderlineIndex = title.indexOf("__");
    return title.slice(doubleUnderlineIndex + 2);
  };

  const addToExistingNotesForNoteId = (containerId, noteId) => {
    const existing = ExistingNotesForNoteId.find(e => e.ContainerId === containerId);
    if (existing) {
      existing.NoteIds.push(noteId);
    } else {
      ExistingNotesForNoteId.push({
        WorkItemId: workItemObject.Id,
        DocumentId: workItemObject.DocumentId,
        Source: workItemObject.Source,
        ContainerId: containerId,
        NoteIds: [noteId],
      });
    }
  };

  const changeButtonsForExistingComments = (elementInWord) => {
    try {
      let buttonElement = document.querySelectorAll(`button[tag=${CSS.escape(elementInWord.tag)}]`);

      if (buttonElement[0]) {
        buttonElement[0].setAttribute("noteid", elementInWord.noteId);
        buttonElement[0].classList.remove("addNote");
        buttonElement[0].classList.add("removeNote");
      } else {
        sendLog("ERROR", "Couldnot find the button for the note", "StarNote", elementInWord.tag);
      }
    } catch (error) {
      sendLog("ERROR", "Couldnot find the button for the note", "StarNote", elementInWord.tag);
      console.log("Couldnot find the button with this Id ", elementInWord.tag);
    }
  };

  const findingTheNodeToAddSelection = (element) => {
    let sectionElement = document.querySelectorAll(`section#${CSS.escape(element.sectionId)}`);
    return walkThroughChildNodesToFindNodeToAddComment(sectionElement[0], element.startPosition, element.endPosition);
  };

  const countElementsLength = (element) => {
    let textContent = "";
    element.textContent
      ? (textContent = element.textContent
          .replace(/ \n\n/g, "")
          .replace(/\n\n /g, "")
          .replace(/\n /g, "")
          .replace(/ \n/g, "")
          .replace(/\n/g, "")
          .replace(/\s\s\s+/g, "") // textContent creates some wrong whitespaces on li html elements
          .trim())
      : "";
    return textContent.length;
  };

  const walkThroughChildNodesToFindNodeToAddComment = (element, startPosition, endPosition) => {
    let positionCounter = 0;
    let nodeName = element.nodeName;
    let childNodesLength = element.childNodes.length;
    if (nodeName == "P" || nodeName == "SPAN") {
      return [element, startPosition, endPosition];
    } else {
      for (let index = 0; index < childNodesLength; index++) {
        const childElement = element.childNodes[index];

        let childElementLength = countElementsLength(childElement);

        positionCounter += childElementLength;
        if (positionCounter > startPosition) {
          const newStartPosition = startPosition - (positionCounter - childElementLength);
          const newEndPosition = endPosition - (positionCounter - childElementLength);
          return walkThroughChildNodesToFindNodeToAddComment(childElement, newStartPosition, newEndPosition);
        }
      }
    }
  };

  const findChildsInvolvedInsideParagraph = (element, startPosition, endPosition) => {
    let positionCounter = 0;
    let childsArray = [];
    let childNodesCount = element.childNodes.length;
    for (let index = 0; index < childNodesCount; index++) {
      const childElement = element.childNodes[index];
      let textContent = childElement.textContent.replace(/\n\s*/g, "").replace(/\n/g, "");
      let textContentLength = textContent.length;
      positionCounter += textContentLength;
      if (positionCounter > startPosition && positionCounter - textContentLength < endPosition) {
        childsArray.push(index);
        childsArray.push(childElement);
      }
    }
    return childsArray;
  };

  const addCommentToPlainText = (childArray, startPosition, endPosition, tag, positionInSection, noteId) => {
    let element = childArray[1];
    let newStartPosition = startPosition;
    let newEndPosition = endPosition;
    for (let i = 0; i < childArray[0]; i++) {
      const el = element.parentElement.childNodes[i];
      const length = el.textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length;
      newStartPosition -= length;
      newEndPosition -= length;
    }
    const text = element.textContent.replace(/\n\s*/g, "").replace(/\n/g, "");
    const text1 = text.slice(0, newStartPosition);
    const text2 = text.slice(newStartPosition, newEndPosition);
    const text3 = text.slice(newEndPosition);
    let parentElement = element.parentElement;
    var span = document.createElement("span");
    span.className = "highlight1";
    span.setAttribute("data-kw-tag", tag);
    span.setAttribute("data-kw-position", positionInSection);
    span.setAttribute("data-kw-noteid", noteId);
    span.appendChild(document.createTextNode(text2));
    element.after(document.createTextNode(text3));
    element.after(span);
    element.after(document.createTextNode(text1));
    parentElement.removeChild(element);
  };

  const addCommentToAnotherLayer = (pElement, startPosition, endPosition, tag, positionInSection, noteId) => {
    let foo = findThreeTypesofConflictingElements(pElement, startPosition, endPosition);
    let startCutElement = foo[0];
    let insideElementsArray = foo[1];
    let endCutElement = foo[2];
    let commentLevel = findCurrentCommentLevel(startCutElement, insideElementsArray);
    let startCutElementStartPosition = elementStartPositionFinder(startCutElement);
    let endCutElementStartPosition = elementStartPositionFinder(endCutElement);
    changeHTMLforStartCutElement(
      commentLevel,
      startCutElement,
      startPosition,
      startCutElementStartPosition,
      tag,
      positionInSection,
      noteId
    );
    changeHTMLforInsideArrayElements(commentLevel, insideElementsArray, tag, positionInSection, noteId);
    changeHTMLforEndCutElement(
      commentLevel,
      endCutElement,
      endPosition,
      endCutElementStartPosition,
      tag,
      positionInSection,
      noteId
    );
  };

  const findThreeTypesofConflictingElements = (pElement, startPosition, endPosition) => {
    let startCutElement = "";
    let insideArray = [];
    let endCutElement = "";
    let tempStartPosition = 0;
    let tempEndPosition = 0;
    for (let index = 0; index < pElement.childNodes.length; index++) {
      const element = pElement.childNodes[index];
      tempEndPosition += element.textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length;
      if (tempStartPosition < startPosition && tempEndPosition > startPosition && tempEndPosition <= endPosition) {
        startCutElement = element;
      } else if (tempStartPosition >= startPosition && tempEndPosition <= endPosition) {
        insideArray.push(element);
      } else if (
        tempStartPosition >= startPosition &&
        tempStartPosition < endPosition &&
        tempEndPosition > endPosition
      ) {
        endCutElement = element;
      }
      tempStartPosition = tempEndPosition;
    }
    return [startCutElement, insideArray, endCutElement];
  };

  const findCurrentCommentLevel = (startCutElement, insideElementsArray) => {
    let levelOfStartCutElement;
    if (!startCutElement) {
      startCutElement = insideElementsArray[0].previousSibling;
    }
    if (startCutElement) {
      levelOfStartCutElement = getCommentLevelFromElement(startCutElement);
    } else {
      levelOfStartCutElement = 0;
    }
    return levelOfStartCutElement + 1;
  };

  const elementStartPositionFinder = (element) => {
    let elementStartPosition = 0;
    let previousSiblingElement = element.previousSibling;
    while (previousSiblingElement) {
      elementStartPosition += previousSiblingElement.textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length;
      previousSiblingElement = previousSiblingElement.previousSibling;
    }
    return elementStartPosition;
  };

  const getCommentLevelFromElement = (element) => {
    if (element.nodeName == "SPAN") {
      return parseInt(element.className.slice(9));
    } else {
      return 0;
    }
  };

  const changeHTMLforStartCutElement = (
    commentLevel,
    startCutElement,
    startPosition,
    startCutElementStartPosition,
    tag,
    positionInSection,
    noteId
  ) => {
    if (startCutElement) {
      let text1 = startCutElement.textContent
        .replace(/\n\s*/g, "")
        .replace(/\n/g, "")
        .slice(0, startPosition - startCutElementStartPosition);
      let text2 = startCutElement.textContent
        .replace(/\n\s*/g, "")
        .replace(/\n/g, "")
        .slice(startPosition - startCutElementStartPosition);
      startCutElement.textContent = text1;
      let span;
      if (startCutElement.nodeName == "SPAN") {
        span = startCutElement.cloneNode(true);
      } else if (startCutElement.nodeName == "#text") {
        span = document.createElement("span");
      }
      span.textContent = text2;
      span.className = "highlight" + commentLevel;
      let newTag;
      let newNoteId;
      let newPositionInSection;
      if (startCutElement.nodeName == "SPAN") {
        newTag = startCutElement.getAttribute("data-kw-tag") + " " + tag;
        newPositionInSection = startCutElement.getAttribute("data-kw-position") + " " + positionInSection;
        newNoteId = startCutElement.getAttribute("data-kw-noteid") + " " + noteId;
        span.setAttribute("data-kw-tag", newTag);
        span.setAttribute("data-kw-position", newPositionInSection);
        span.setAttribute("data-kw-noteid", newNoteId);
      } else if (startCutElement.nodeName == "#text") {
        span.setAttribute("data-kw-tag", tag);
        span.setAttribute("data-kw-position", positionInSection);
        span.setAttribute("data-kw-noteid", noteId);
      }
      startCutElement.after(span);
    }
  };

  const changeHTMLforInsideArrayElements = (commentLevel, insideElementsArray, tag, positionInSection, noteId) => {
    let overrideLevel = 0;
    insideElementsArray.forEach((insideElement) => {
      if (insideElement.nodeName == "SPAN") {
        let previousTag = insideElement.getAttribute("data-kw-tag");
        let previousPositionInSection = insideElement.getAttribute("data-kw-position");
        let previousNoteId = insideElement.getAttribute("data-kw-noteid");
        let insideElementCommentLevel = getCommentLevelFromElement(insideElement);
        let newCommentLevelforInsideElement;
        newCommentLevelforInsideElement = insideElementCommentLevel + commentLevel - overrideLevel;
        if (newCommentLevelforInsideElement > 3) {
          overrideLevel = newCommentLevelforInsideElement - 3;
          newCommentLevelforInsideElement = 3;
        }
        insideElement.className = "highlight" + newCommentLevelforInsideElement;
        insideElement.setAttribute("data-kw-tag", previousTag + " " + tag);
        insideElement.setAttribute("data-kw-position", previousPositionInSection + " " + positionInSection);
        insideElement.setAttribute("data-kw-noteid", previousNoteId + " " + noteId);
      } else if (insideElement.nodeName == "#text") {
        let span = document.createElement("span");
        span.textContent = insideElement.textContent.replace(/\n\s*/g, "").replace(/\n/g, "");
        span.className = "highlight" + commentLevel;
        span.setAttribute("data-kw-tag", tag);
        span.setAttribute("data-kw-position", positionInSection);
        span.setAttribute("data-kw-noteid", noteId);
        insideElement.after(span);
        insideElement.remove();
      }
    });
  };

  const changeHTMLforEndCutElement = (
    commentLevel,
    endCutElement,
    endPosition,
    endCutElementStartPosition,
    tag,
    positionInSection,
    noteId
  ) => {
    if (endCutElement) {
      let text1 = endCutElement.textContent
        .replace(/\n\s*/g, "")
        .replace(/\n/g, "")
        .slice(0, endPosition - endCutElementStartPosition);
      let text2 = endCutElement.textContent
        .replace(/\n\s*/g, "")
        .replace(/\n/g, "")
        .slice(endPosition - endCutElementStartPosition);
      endCutElement.textContent = text2;
      let span = document.createElement("span");
      span.textContent = text1;
      span.className = "highlight" + commentLevel;
      span.setAttribute("data-kw-tag", tag);
      span.setAttribute("data-kw-position", positionInSection);
      span.setAttribute("data-kw-noteid", noteId);
      endCutElement.before(span);
    }
  };

  // ----------------- end of loading and applying existing tags ------------------

  // ----------------- Start of changes summaries ------------------

  async function addChangesSummariesButtons() {
    let changesSummaries = await getChangesSummaries();

    if (changesSummaries != false) {
      const hasNonEmptyChangeHtml = changesSummaries.ParagraphSummaries.some(
        (obj) => obj.ChangeHtml.trim() !== "" && obj.ChangeHtml != null
      );
      if (hasNonEmptyChangeHtml) {
        setHasLawChangesToTrue();

        changesSummaries.ParagraphSummaries.forEach((change) => {
          if (change.ChangeHtml) {
            addChangesSummaryButtonToParagraph(change);
          }
        });

        let toggleButtons = document.querySelectorAll("button.toggleChanges");
        toggleButtons.forEach((btn) => {
          let id = btn.id;
          btn.addEventListener("click", function () {
            toggleChangesSummary(id);
          });
        });
      }
    }
  }

  async function getChangesSummaries() {
    if (changesSummaries != false) {
      return changesSummaries;
    } else {
      let result = await APICalls.getChangesSummaries(workItemObject.Id, decodedTokenObject)
        .then((res) => {
          setChangesSummaries(res);
          return res;
        })
        .catch((error) => {
          console.log("Error on getChanges Summaries api", error);
          sendLog("ERROR", "Error on getChanges Summaries api");
          return false;
        });
      return result;
    }
  }

  function addChangesSummaryButtonToParagraph(change) {
    let section = document.querySelector(`section[id=${CSS.escape(change.SubId)}]`);
    if (section) {
      const div = createChangesSummaryDiv(change);
      const btn = createChangesSummaryButton(change);
      const headers = section.querySelectorAll("h1, h2, h3, h4, h5, h6");
      if (headers.length > 0) {
        const firstHeader = headers[0];
        try {
          firstHeader.after(div);
          firstHeader.after(btn);
        } catch (error) {
          sendLog("Warning", "addChangesSummaryButtonToParagraph", error, change.SubId);
          console.log("Add div error", error);
        }
      } else {
        sendLog("INFO", "AddNote", "Highlight", tag);
        console.log("Header not found for ", change.SubId);
      }
    }
  }

  function createChangesSummaryButton(change) {
    const button = document.createElement("button");
    button.innerHTML = "Se endringer";
    button.className = "toggleChanges";
    button.id = change.SubId;

    return button;
  }

  function createChangesSummaryDiv(change) {
    var container = document.createElement("div");
    container.className = "changesContent";
    container.id = change.SubId;

    var changesHeaderContainer = document.createElement("h3");
    changesHeaderContainer.className = "changesHeader";
    changesHeaderContainer.textContent = "Sammenlign versjoner";

    let changesContainer = document.createElement("div");
    changesContainer.className = "changesDiv";
    changesContainer.innerHTML = change.ChangeHtml;
    changesContainer = ConvertXMLtoHTML(changesContainer);

    var AIHeaderContainer = document.createElement("h3");
    AIHeaderContainer.className = "changesHeader";
    AIHeaderContainer.textContent = "Oppsummering av endring (AI)";

    let AIGeneratedSuggesionContainer = document.createElement("div");
    AIGeneratedSuggesionContainer.className = "AIGeneratedSuggesionDiv";
    if (change.Summaries[0]) {
      try {
        AIGeneratedSuggesionContainer.innerHTML = change.Summaries[0].replace(/\n/g, "<br>");
      } catch (error) {
        console.log("Error AIGeneratedSuggesion", error);
      }
    }

    container.appendChild(changesHeaderContainer);
    container.appendChild(changesContainer);

    // Temporarily commented of AI generated texts
    // container.appendChild(AIHeaderContainer);
    // container.appendChild(AIGeneratedSuggesionContainer);

    container.style.display = "none";
    return container;
  }

  function toggleChangesSummary(id) {
    let btn = document.querySelector(`button[id=${CSS.escape(id)}].toggleChanges`);
    let div = document.querySelector(`div[id=${CSS.escape(id)}].changesContent`);
    if (div.style.display === "none") {
      div.style.display = "block";
      btn.innerHTML = "Gjemme endringer";
    } else {
      div.style.display = "none";
      btn.innerHTML = "Se endringer";
    }
  }

  function setHasLawChangesToTrue() {
    if (accessesObject.HasLawChanges != true) {
      setAccessesObject((prevState) => ({
        ...prevState,
        HasLawChanges: true,
      }));
    }
  }

  // ----------------- End of changes summaries ------------------

  // ----------------- start of Remove TextSelection  ------------------

  const checkRemoveTextSelectionButtons = (event) => {
    hideModalElements();
    let targetNode = event.target;

    if (
      targetNode.nodeName == "SPAN" &&
      targetNode.className.startsWith("highlight") &&
      targetNode.hasAttribute("data-kw-tag")
    ) {
      // const targetSectionId = parentSectionAttributeFinder(targetNode, "id");
      // let parentNode = window.getSelection().anchorNode.parentNode;
      // let parentNode = window.getSelection().anchorNode;
      // if (targetNode.nodeName == "SPAN" && targetNode.hasAttribute("data-kw-tag")) {
      const targetSectionId = parentSectionAttributeFinder(targetNode, "id");
      window.getSelection().empty();
      let parentTagsArray = getTagsArrayFromElement(targetNode);
      wordAPI.goToComment(parentTagsArray[0]);
      if (subIds.includes(targetSectionId) && accessesObject.CanAddNotes == true) {
        let commentLevel = getCommentLevelFromElement(targetNode);
        let tagsLevel = [];
        neighbourElementsArray = [];
        if (parentTagsArray.length == 1) {
          tagsLevel[commentLevel - 1] = parentTagsArray[0];
        } else if (parentTagsArray.length == 2) {
          if (commentLevel == 2) {
            tagsLevel = findTwoTagsLevelForCommentLevelTwo(targetNode, parentTagsArray);
          } else if (commentLevel == 3) {
            tagsLevel = findTwoTagsLevelForCommentLevelThree(targetNode, parentTagsArray);
          }
        } else if (parentTagsArray.length == 3) {
          tagsLevel = findThreeTagsLevel(targetNode, parentTagsArray);
        }
        showRemoveButtonTextSelection(targetNode, tagsLevel);
      }
      // }
    }
  };

  const getTagsArrayFromElement = (element) => {
    if (element.nodeName == "SPAN") {
      return element.getAttribute("data-kw-tag").split(" ");
    } else {
      return [];
    }
  };

  const showRemoveButtonTextSelection = (parentNode, tagsLevel) => {
    // // start of Check
    // let parentTagsArray = getTagsArrayFromElement(parentNode);
    // let length1 = parentTagsArray.length;
    // console.log("*********************************************************************************************");
    // parentTagsArray.forEach((tag) => {
    //   console.log("parentTagsArray", tag);
    // });
    // console.log("--------");
    // let length2 = 0;
    // for (let index = 0; index < 3; index++) {
    //   const tag = tagsLevel[index];
    //   console.log("tagsLevel ", index + 1, "    ", tag);
    //   if (tag) {
    //     length2++;
    //   }
    // }
    // if (length1 != length2) {
    //   console.log("ERORRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR");
    // }
    // // end of Check

    let leftPosition = parentNode.offsetLeft;
    const topPosition = parentNode.offsetTop - 27;
    let containerId = parentSectionAttributeFinder(parentNode, "data-sl-semanticpath");
    let sectionId = parentSectionAttributeFinder(parentNode, "id");
    let button1 = document.querySelectorAll("#textSelectionRemove1");
    let button2 = document.querySelectorAll("#textSelectionRemove2");
    let button3 = document.querySelectorAll("#textSelectionRemove3");
    if (tagsLevel[0]) {
      button1[0].style = `display:block; top: ${topPosition}px; left: ${leftPosition}px;`;
      button1[0].setAttribute("tag", tagsLevel[0]);
      button1[0].setAttribute("sectionId", sectionId);
      button1[0].setAttribute("containerId", containerId);
      leftPosition += 25;
    } else {
      button1[0].style = "";
    }
    if (tagsLevel[1]) {
      button2[0].style = `display:block; top: ${topPosition}px; left: ${leftPosition}px;`;
      button2[0].setAttribute("tag", tagsLevel[1]);
      button2[0].setAttribute("sectionId", sectionId);
      button2[0].setAttribute("containerId", containerId);
      leftPosition += 25;
    } else {
      button2[0].style = "";
    }
    if (tagsLevel[2]) {
      button3[0].style = `display:block; top: ${topPosition}px; left: ${leftPosition}px;`;
      button3[0].setAttribute("tag", tagsLevel[2]);
      button3[0].setAttribute("sectionId", sectionId);
      button3[0].setAttribute("containerId", containerId);
    } else {
      button3[0].style = "";
    }
  };

  const findTwoTagsLevelForCommentLevelTwo = (parentNode, parentTagsArray) => {
    collectSiblingElementsInOrder(parentNode);
    let tagsLevel = [];
    neighbourElementsArray.forEach((element) => {
      let siblingTagsArray = getTagsArrayFromElement(element);
      let siblingLevel = getCommentLevelFromElement(element);
      if (siblingTagsArray.length == 1 && parentTagsArray.includes(siblingTagsArray[0])) {
        tagsLevel[siblingLevel - 1] = siblingTagsArray[0];
      }
    });

    // in case of not having level one - since in this case the layer two is inside the layer one so the longer tag is the first layer tag
    if (!tagsLevel[0]) {
      parentTagsArray[0].length > parentTagsArray[1].length
        ? (tagsLevel[0] = parentTagsArray[0])
        : (tagsLevel[0] = parentTagsArray[1]);
    }

    //find tags connected to level 2
    if (!tagsLevel[1]) {
      parentTagsArray.forEach((tag) => {
        if (tag != tagsLevel[0] && parentTagsArray.includes(tag) && !tagsLevel[1]) {
          tagsLevel[1] = tag;
        }
      });
    }
    return tagsLevel;
  };
  const findTwoTagsLevelForCommentLevelThree = (parentNode, parentTagsArray) => {
    collectSiblingElementsInOrder(parentNode);
    let tagsLevel = [];

    //find tags connected to single tag spans
    neighbourElementsArray.forEach((element) => {
      let siblingTagsArray = getTagsArrayFromElement(element);
      let siblingLevel = getCommentLevelFromElement(element);
      if (siblingTagsArray.length == 1 && parentTagsArray.includes(siblingTagsArray[0])) {
        tagsLevel[siblingLevel - 1] = siblingTagsArray[0];
      }
    });

    if (!tagsLevel[0] && !tagsLevel[1]) {
      neighbourElementsArray.forEach((element) => {
        let siblingTagsArray = getTagsArrayFromElement(element);
        let siblingLevel = getCommentLevelFromElement(element);
        if (siblingTagsArray.length == 2 && siblingLevel == 2) {
          siblingTagsArray.forEach((tag) => {
            if (tag != tagsLevel[0] && !tagsLevel[1] && parentTagsArray.includes(tag)) {
              tagsLevel[1] = tag;
            }
          });
        } else if (
          siblingTagsArray.length == 1 &&
          siblingLevel == 2 &&
          parentTagsArray.includes(siblingTagsArray[0]) &&
          !tagsLevel[1]
        ) {
          tagsLevel[1] = tag;
        }
      });
    }

    //find tags connected to level 3
    if (!tagsLevel[2]) {
      parentTagsArray.forEach((tag) => {
        if (
          tag != tagsLevel[0] &&
          tag != tagsLevel[1] &&
          parentTagsArray.includes(tag) &&
          (!tagsLevel[1] || !tagsLevel[0])
        ) {
          tagsLevel[2] = tag;
        }
      });
    }
    return tagsLevel;
  };

  const findThreeTagsLevel = (parentNode, parentTagsArray) => {
    collectSiblingElementsInOrder(parentNode);
    let tagsLevel = [];

    //find tags connected to single tag spans
    neighbourElementsArray.forEach((element) => {
      let siblingTagsArray = getTagsArrayFromElement(element);
      let siblingLevel = getCommentLevelFromElement(element);
      if (siblingTagsArray.length == 1 && parentTagsArray.includes(siblingTagsArray[0])) {
        tagsLevel[siblingLevel - 1] = siblingTagsArray[0];
      }
    });

    // in case of not having level one and the tag is common between two of the highlight2 layers
    if (!tagsLevel[0]) {
      let firstElem = "";
      let secondElem = "";
      neighbourElementsArray.forEach((element) => {
        let siblingTagsArray = getTagsArrayFromElement(element);
        let siblingLevel = getCommentLevelFromElement(element);
        if (siblingTagsArray.length == 2 && siblingLevel == 2) {
          firstElem = secondElem;
          secondElem = element;
          if (firstElem && secondElem) {
            let firstElemTagsArray = getTagsArrayFromElement(firstElem);
            let secondElemTagsArray = siblingTagsArray;
            secondElemTagsArray.forEach((tag) => {
              if (firstElemTagsArray.includes(tag) && parentTagsArray.includes(tag) && !tagsLevel[0]) {
                tagsLevel[0] = tag;
              }
            });
          }
        }
      });
    }

    // in case of not having level one and the tag is common between two neigbours and the parentnode itself
    if (!tagsLevel[0]) {
      for (let index = 0; index < neighbourElementsArray.length - 1; index++) {
        const el = neighbourElementsArray[index];
        const nextEl = neighbourElementsArray[index + 1];
        let siblingTagsArray = getTagsArrayFromElement(el);
        let nextSiblingTagsArray = getTagsArrayFromElement(nextEl);
        siblingTagsArray.forEach((tag) => {
          if (parentTagsArray.includes(tag) && nextSiblingTagsArray.includes(tag) && !tagsLevel[0]) {
            tagsLevel[0] = tag;
          }
        });
      }
    }

    //find tags connected to level 2
    if (!tagsLevel[1]) {
      neighbourElementsArray.forEach((element) => {
        let siblingTagsArray = getTagsArrayFromElement(element);
        let siblingLevel = getCommentLevelFromElement(element);
        if (siblingTagsArray.length == 2 && siblingLevel == 2 && parentTagsArray.includes(siblingTagsArray[0])) {
          siblingTagsArray.forEach((tag) => {
            if (tag != tagsLevel[0] && !tagsLevel[1]) {
              tagsLevel[1] = tag;
            }
          });
        } else if (
          siblingTagsArray.length == 1 &&
          siblingLevel == 2 &&
          parentTagsArray.includes(siblingTagsArray[0]) &&
          !tagsLevel[1]
        ) {
          tagsLevel[1] = tag;
        }
      });
    }

    //find tags connected to level 3
    if (!tagsLevel[2]) {
      parentTagsArray.forEach((tag) => {
        if (tag != tagsLevel[0] && tag != tagsLevel[1] && parentTagsArray.includes(tag) && !tagsLevel[2]) {
          tagsLevel[2] = tag;
        }
      });
    }
    return tagsLevel;
  };

  const collectSiblingElementsInOrder = (parentNode) => {
    let FirstElem = findFirstNeighbourInOrder(parentNode);

    if (!parentNode.isEqualNode(FirstElem)) {
      neighbourElementsArray.push(FirstElem);
    }
    collectNextSiblingElements(FirstElem, parentNode);
  };

  const findFirstNeighbourInOrder = (element) => {
    let previousElement = element.previousSibling;
    if (previousElement) {
      if (previousElement.nodeName == "SPAN") {
        return findFirstNeighbourInOrder(previousElement);
      }
    }
    return element;
  };

  const collectNextSiblingElements = (element, parentNode) => {
    let nextElement = element.nextSibling;
    if (nextElement) {
      if (nextElement.nodeName == "SPAN") {
        if (!nextElement.isEqualNode(parentNode)) {
          neighbourElementsArray.push(nextElement);
        }
        collectNextSiblingElements(nextElement, parentNode);
      }
    }
  };

  const hideModalElements = () => {
    document.querySelector("#textSelectionRemove1").style = "";
    document.querySelector("#textSelectionRemove2").style = "";
    document.querySelector("#textSelectionRemove3").style = "";
    document.querySelector("#textSelectionAdd1").style = "";
    document.querySelector("#textSelectionAdd2").style = "";
    document.querySelector("#textSelectionAdd3").style = "";
    document.querySelector(".removeModal").style = "";
    document.querySelector(".docOpsModal").style = "";
  };

  // ----------------- end of Remove TextSelection  ------------------

  // ----------------- start of Add TextSelection  ------------------

  const checkForAddTextSelectionButtons = (event) => {
    try {
      hideModalElements();
      let targetNode = event.target;
      const targetSectionId = parentSectionAttributeFinder(targetNode, "id");
      let isChangesSummary = IsNodeChangesSummary(targetNode);
      if (
        subIds.includes(targetSectionId) &&
        !isChangesSummary &&
        (targetNode.nodeName == "P" ||
          (targetNode.nodeName == "SPAN" && targetNode.className.startsWith("highlight")) ||
          (targetNode.nodeName == "DIV" && targetNode.lastElementChild?.nodeName == "P") ||
          (targetNode.nodeName == "EM" && targetNode.parentElement?.nodeName == "P"))
      ) {
        const selectedHtml = getSelectionHtml().toString();
        const checkEndTag = hasEndTags(selectedHtml);
        let getSelection = window.getSelection();
        // console.log("getSelection", getSelection);
        let text = getSelectedText();
        let badCharsIndex = badChars.indexOf(text);
        if (!checkEndTag && text && badCharsIndex < 0) {
          extendSelectedText(getSelection);
          getSelection = window.getSelection();
          text = getSelectedText();
          // console.log("getSelection", getSelection);
          let [commentLevel, pElement, startPosition, finishPosition] = checkLevelOfSelection(getSelection);
          // console.log("checkLevelOfSelection", commentLevel, pElement, startPosition, finishPosition);
          if (commentLevel > 0 && commentLevel <= 3) {
            let validityCheck = validityCheckForAddSelectionComment(commentLevel, getSelection);
            if (validityCheck) {
              let tag = createTagForAddComment(pElement, text);
              let title = createTitleForAddComment(pElement, text, startPosition, finishPosition);
              let positionInSection = findPositionInSectionFromTitle(title);
              let sectionId = parentSectionAttributeFinder(pElement, "id");
              let paragraphId = pElement.id;
              showAddButtonTextSelection(commentLevel, tag, title, positionInSection, text, sectionId, paragraphId);
            }
          }
        }
      }
    } catch (error) {
      console.log("Error - handling selection", error);
    }
  };

  const IsNodeChangesSummary = (element) => {
    let counter = 0;
    while (counter < 10) {
      if (element.nodeName == "DIV" || element.nodeName == "BUTTON") {
        if (
          element.classList.contains("changesContent") ||
          element.classList.contains("changesDiv") ||
          element.classList.contains("toggleChanges")
        ) {
          return true;
        }
      }
      if (element.parentNode) {
        element = element.parentNode;
      } else {
        return false;
      }
      counter++;
    }
    return false;
  };

  const extendSelectedText = (getSelection) => {
    let [startNode, startOffset, finishNode, finishOffset] = sortAnchorFocusNode(getSelection);
    // console.log("startNode, startOffset, finishNode, finishOffset", startNode, startOffset, finishNode, finishOffset);
    let newStartOffset = findNewStartOffset(startNode, startOffset);
    let newFinishOffset = findNewFinishOffset(finishNode, finishOffset);
    // console.log("newStartOffset , newFinishOffset", newStartOffset, newFinishOffset);

    let range = document.createRange();

    if (startNode.nodeName == "SPAN" || finishNode.nodeName == "EM") {
      startNode = startNode.firstChild;
    }

    if (finishNode.nodeName == "SPAN" || finishNode.nodeName == "EM") {
      finishNode = finishNode.firstChild;
    }
    range.setStart(startNode, newStartOffset);
    range.setEnd(finishNode, newFinishOffset);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
  };

  const sortAnchorFocusNode = (getSelection) => {
    let anchorNode;
    let focusNode;
    if (getSelection.anchorNode.parentNode.nodeName == "P") {
      anchorNode = getSelection.anchorNode;
    } else {
      anchorNode = getSelection.anchorNode.parentNode;
    }
    const anchorOffset = getSelection.anchorOffset;
    // const pElement = anchorNode.parentNode;
    if (getSelection.focusNode.parentNode.nodeName == "P") {
      focusNode = getSelection.focusNode;
    } else {
      focusNode = getSelection.focusNode.parentNode;
    }
    const focusOffset = getSelection.focusOffset;

    let isAnchorNodeFirst = true;

    if (anchorNode.isEqualNode(focusNode)) {
      if (anchorOffset > focusOffset) {
        isAnchorNodeFirst = false;
      }
    } else {
      if (anchorNode.previousSibling) {
        let hasResult = false;
        let checkNode = anchorNode.previousSibling;
        while (!hasResult) {
          if (checkNode.isEqualNode(focusNode)) {
            isAnchorNodeFirst = false;
            hasResult = true;
          } else {
            if (checkNode.previousSibling) {
              checkNode = checkNode.previousSibling;
            } else {
              hasResult = true;
            }
          }
        }
      }
    }
    if (isAnchorNodeFirst) {
      return [anchorNode, anchorOffset, focusNode, focusOffset];
    } else {
      return [focusNode, focusOffset, anchorNode, anchorOffset];
    }
  };
  const findNewStartOffset = (node, offset) => {
    let textContent = node.textContent;
    let textContentLength = textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length;
    let char = textContent.charAt(offset);
    let badCharsIndex = badChars.indexOf(char);
    if (badCharsIndex < 0) {
      if (offset == 0 || offset == textContentLength) {
        return offset;
      } else {
        let previousChar = textContent.charAt(offset - 1);
        let badPreviousCharsIndex = badChars.indexOf(previousChar);
        if (badPreviousCharsIndex < 0) {
          return findNewStartOffset(node, offset - 1);
        } else {
          return offset;
        }
      }
    } else {
      return findNewStartOffset(node, offset + 1);
    }
  };

  const findNewFinishOffset = (node, offset) => {
    let badCharsForFinishOffset = badChars.filter((c) => c != ".");

    let textContent = node.textContent;
    let textContentLength = textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length;
    let char = textContent.charAt(offset - 1);
    let badCharsIndex = badCharsForFinishOffset.indexOf(char);
    if (badCharsIndex < 0) {
      if (offset == 0 || offset == textContentLength) {
        return offset;
      } else {
        let nextChar = textContent.charAt(offset);
        let badNextCharsIndex = badChars.indexOf(nextChar);
        if (badNextCharsIndex < 0) {
          return findNewFinishOffset(node, offset + 1);
        } else {
          return offset;
        }
      }
    } else {
      return findNewFinishOffset(node, offset - 1);
    }
  };

  const validityCheckForAddSelectionComment = (commentLevel, getSelection) => {
    let startNode = getSelection.anchorNode;
    let finishNode = getSelection.focusNode;
    if (startNode.parentNode.nodeName != "P") {
      startNode = startNode.parentNode;
    }
    if (finishNode.parentNode.nodeName != "P") {
      finishNode = finishNode.parentNode;
    }
    let hasLevelThree = checkForLevelThreeInSelectedText(startNode, finishNode);
    if (hasLevelThree) {
      return false;
    }
    let checkInsideElementsCompatibility = checkInsideElementsLevelCompatibility(startNode, finishNode, commentLevel);
    // console.log("checkInsideElementsCompatibility", checkInsideElementsCompatibility);
    if (!checkInsideElementsCompatibility) {
      return false;
    }
    let checkElementsAfterFinishCompatibility = checkElementsAfterFinishNode(startNode, finishNode, commentLevel);
    if (!checkElementsAfterFinishCompatibility) {
      return false;
    }

    return true;
  };

  const checkInsideElementsLevelCompatibility = (startNode, finishNode, commentLevel) => {
    if (!startNode.isEqualNode(finishNode)) {
      let startNodeTags = getTagsArrayFromElement(startNode);
      let checkNode = startNode;
      while (!checkNode.isEqualNode(finishNode)) {
        checkNode = checkNode.nextSibling;
        let checkNodeTags = getTagsArrayFromElement(checkNode);
        let currentLevel = getCommentLevelFromElement(checkNode);
        let commonTagCounter = 0;
        startNodeTags.forEach((tag) => {
          if (checkNodeTags.includes(tag)) {
            commonTagCounter++;
          }
        });
        let newLevel = commentLevel + currentLevel - commonTagCounter;
        // console.log("newLevel", newLevel, currentLevel, commentLevel, commonTagCounter);
        if (newLevel > 3) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }
  };

  const checkElementsAfterFinishNode = (startNode, finishNode, commentLevel) => {
    if (finishNode.nodeName == "SPAN" && finishNode.nextSibling) {
      let startNodeTags = getTagsArrayFromElement(startNode);
      let finishNodeTags = getTagsArrayFromElement(finishNode);
      let increasedLevel = 0;
      startNodeTags.forEach((tag) => {
        if (!finishNodeTags.includes(tag)) {
          increasedLevel++;
        }
      });
      finishNodeTags.forEach((tag) => {
        if (!startNodeTags.includes(tag)) {
          increasedLevel++;
        }
      });
      if (increasedLevel > 0) {
        let checkNode = finishNode.nextSibling;
        let reachedSameLevel = false;
        while (checkNode.nodeName == "SPAN" && !reachedSameLevel) {
          let checkNodeTags = getTagsArrayFromElement(checkNode);
          let currentLevel = getCommentLevelFromElement(checkNode);

          let newLevel = currentLevel + increasedLevel;
          // console.log("newLevel", checkNode, newLevel);

          //compare tags from start node to check node to see if it is a base comment
          if (JSON.stringify(checkNodeTags) === JSON.stringify(startNodeTags)) {
            reachedSameLevel = true;
          } else {
            if (newLevel > 3) {
              return false;
            }
          }
          checkNode = checkNode.nextSibling;
        }
      }
    }
    return true;
  };
  const checkForLevelThreeInSelectedText = (startNode, finishNode) => {
    const startLevel = getCommentLevelFromElement(startNode);
    const finishLevel = getCommentLevelFromElement(finishNode);
    if (startLevel > 2 || finishLevel > 2) {
      return true;
    }

    if (!startNode.isEqualNode(finishNode)) {
      let checkNode = startNode.nextSibling;
      while (!checkNode.isEqualNode(finishNode)) {
        const level = getCommentLevelFromElement(checkNode);
        if (level > 2) {
          return true;
        }
        checkNode = checkNode.nextSibling;
      }
    }
    return false;
  };

  const checkLevelOfSelection = (getSelection) => {
    let commentLevel = 0;
    let anchorNode = getSelection.anchorNode;
    let focusNode = getSelection.focusNode;
    if (anchorNode.parentNode.nodeName != "P") {
      anchorNode = anchorNode.parentNode;
    }
    if (focusNode.parentNode.nodeName != "P") {
      focusNode = focusNode.parentNode;
    }
    const anchorOffset = getSelection.anchorOffset;
    const focusOffset = getSelection.focusOffset;
    const pElement = anchorNode.parentNode;
    let [startNode, startOffset, finishNode, finishOffset, startCountInParagraph, finishCountInParagraph] =
      sortAndCountsInParagraph(pElement, anchorNode, anchorOffset, focusNode, focusOffset);

    commentLevel = findCommentLevelToAdd(pElement, startNode, startOffset, finishNode);

    return [commentLevel, pElement, startCountInParagraph, finishCountInParagraph];
  };

  const findCommentLevelToAdd = (pElement, startNode, startOffset, finishNode) => {
    let startNodeLevel = getCommentLevelFromElement(startNode);
    let finishNodeLevel = getCommentLevelFromElement(finishNode);
    let commentLevel = 0;
    let isItExistedComment = checkForIsItExistedComment(pElement, startNode);
    if (isItExistedComment) {
      return false;
    }
    if (startNode.nodeName == "#text") {
      return 1;
    }
    if (startOffset > 0) {
      return startNodeLevel + 1;
    }
    if (finishNode.nodeName == "#text") {
      if (startNode.previousSibling) {
        let previousNode = startNode.previousSibling;
        if (
          previousNode.nodeName == "#text" ||
          previousNode.textContent.replace(/\n\s*/g, "").replace(/\n/g, "").length == 0
        ) {
          commentLevel = 1;
        } else {
          commentLevel = startNodeLevel;
        }
      } else {
        commentLevel = 1;
      }
    } else {
      let isAllTagIncludedAtEnd = true;
      const startTagsArray = getTagsArrayFromElement(startNode);
      const finishTagsArray = getTagsArrayFromElement(finishNode);
      startTagsArray.forEach((tag) => {
        if (!finishTagsArray.includes(tag)) {
          isAllTagIncludedAtEnd = false;
        }
      });
      if (isAllTagIncludedAtEnd) {
        commentLevel = startNodeLevel + 1;
      } else {
        commentLevel = startNodeLevel;
      }
    }
    return commentLevel;
  };

  const sortAndCountsInParagraph = (pElement, anchorNode, anchorOffset, focusNode, focusOffset) => {
    let positionCounter = 0;
    let positionCount1;
    let positionCount2;
    pElement.childNodes.forEach((childElement) => {
      if (childElement.isEqualNode(anchorNode)) {
        positionCount1 = positionCounter + anchorOffset;
      }
      if (childElement.isEqualNode(focusNode)) {
        positionCount2 = positionCounter + focusOffset;
      }
      if (!positionCount1 || !positionCount2) {
        let textContent = childElement.textContent.replace(/\n\s*/g, "").replace(/\n/g, "");
        let textContentLength = textContent.length;
        positionCounter += textContentLength;
      }
    });

    if (positionCount1 > positionCount2) {
      return [focusNode, focusOffset, anchorNode, anchorOffset, positionCount2, positionCount1];
    } else {
      return [anchorNode, anchorOffset, focusNode, focusOffset, positionCount1, positionCount2];
    }
  };

  const checkForIsItExistedComment = (pElement, startNode) => {
    let result = false;
    let text = getSelectedText();
    let newTag = createTagForAddComment(pElement, text);
    if (startNode.nodeName == "SPAN") {
      const startTagsArray = getTagsArrayFromElement(startNode);
      startTagsArray.forEach((tag) => {
        let newTagSlice = newTag.slice(0, -8);
        let tagSlice = tag.slice(0, -8);
        if (tagSlice == newTagSlice) {
          result = true;
        }
      });
    }

    return result;
  };

  const createTagForAddComment = (pElement, text) => {
    let sectionId = parentSectionAttributeFinder(pElement, "id");
    let newText = text.replaceAll(" ", "_");
    let junk = createJunkForTag();
    return sectionId + "__" + newText + junk;
  };
  const createTitleForAddComment = (pElement, text, startPosition, finishPosition) => {
    // let find what we have before paragraph --countWise
    let baseCount = countCharacterBeforeParagraphInSection(pElement);
    let startCount = baseCount + startPosition;
    let finishCount = baseCount + finishPosition;
    return text + "__" + startCount + "__" + finishCount;
  };

  const createJunkForTag = () => {
    var result = "";
    var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 8; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const countCharacterBeforeParagraphInSection = (pElement) => {
    return walkthroughToFindCharacterCountBeforeParagraph(pElement, pElement, 0, true);
  };

  const walkthroughToFindCharacterCountBeforeParagraph = (pElement, element, count, isParent) => {
    let newCount = count;

    if (element.nodeName == "SECTION") {
      return newCount;
    } else {
      let newElement;
      let newIsParent = false;
      if (element.previousElementSibling) {
        newElement = element.previousElementSibling;
      } else {
        newElement = element.parentNode;
        newIsParent = true;
      }
      if (
        !pElement.isEqualNode(element) &&
        !isParent &&
        !element.classList.contains("toggleChanges") &&
        !element.classList.contains("changesContent")
      ) {
        let elementLength = countElementsLength(element);

        newCount += elementLength;
      }
      return walkthroughToFindCharacterCountBeforeParagraph(pElement, newElement, newCount, newIsParent);
    }
  };

  const showAddButtonTextSelection = (commentLevel, tag, title, positionInSection, phrase, sectionId, paragraphId) => {
    let sel = window.getSelection();
    let oRange = sel.getRangeAt(0); //get the text range
    let oRect = oRange.getBoundingClientRect();
    var relative = document.body.parentNode.getBoundingClientRect();
    let leftPosition = oRect.left - relative.left;
    let topPosition = oRect.bottom - relative.top - oRect.height - 27;
    let idSelector = "#textSelectionAdd" + commentLevel;
    let addButton = document.querySelector(idSelector);
    addButton.setAttribute("data-kw-tag", tag);
    addButton.setAttribute("data-kw-title", title);
    addButton.setAttribute("data-kw-position", positionInSection);
    addButton.setAttribute("data-kw-phrase", phrase);
    addButton.setAttribute("data-kw-sectionId", sectionId);
    addButton.setAttribute("data-kw-paragraphId", paragraphId);
    addButton.style = `display: block; top: ${topPosition}px; left: ${leftPosition}px;`;
  };

  const addTextSelection = (button) => {
    hideModalElements();
    const tag = button.getAttribute("data-kw-tag");
    const title = button.getAttribute("data-kw-title");
    const positionInSection = button.getAttribute("data-kw-position");
    const phrase = button.getAttribute("data-kw-phrase");
    const sectionId = button.getAttribute("data-kw-sectionId");
    const paragraphId = button.getAttribute("data-kw-paragraphId");
    let containerId = document.querySelector(`[id=${CSS.escape(sectionId)}]`).getAttribute("data-sl-semanticpath");
    let lastNoteId = findLastNoteId(sectionId, paragraphId, positionInSection, "textSelection");
    let addAfterTag = findAddAfterTag(lastNoteId, sectionId);
    const docOpsMode = document.querySelector("#lawTab").classList.contains("docOpsMode");
    if (docOpsMode == false) {
      handleActionOfMessageBox("startAddingNote");
      APICalls.newNoteId(containerId, lastNoteId, userInfoObject, workItemObject, decodedTokenObject)
        .then((newNoteIdResult) => {
          wordAPI
            .addNoteFunc(tag, title, phrase, addAfterTag, sectionId, newNoteIdResult.DisplayNewId)
            .then(() => {
              reNumberingNotesForAddNote(
                "textSelection",
                tag,
                title,
                sectionId,
                containerId,
                newNoteIdResult,
                positionInSection,
                addAfterTag
              )
                .then(() => {
                  load().then(() => {
                    handleActionOfMessageBox("successAddingNote");
                    sendLog("INFO", "AddNote", "Highlight", tag);
                    sendMetric("AddNote", "Highlight", "Success", tag);
                  });
                })
                .catch((err) => {
                  console.log("problem with renumbering notes", err);
                  handleActionOfErrorBox("addingNoteFail");
                  sendLog("ERROR", "AddNote", "Highlight", tag + "   problem with renumbering notes");
                });
            })
            .catch((err) => {
              console.log("problem with adding notes to word", err);
              handleActionOfErrorBox("addingNoteFail");
              sendLog("ERROR", "AddNote", "Highlight", tag + "   problem with adding notes to word");
            });
        })
        .catch((err) => {
          console.log("problem with noteId service", err);
          handleActionOfErrorBox("addingNoteFail");
          sendLog("ERROR", "AddNote", "Highlight", tag + "   problem with noteId service");
        });
    } else {
      document.querySelector(".docOpsModal").style.display = "block";
      let docOpsNewTagInfo = document.querySelector(".newTagInfoDocOpsMode");
      docOpsNewTagInfo.setAttribute("tag", tag);
      docOpsNewTagInfo.setAttribute("title", title);
      docOpsNewTagInfo.setAttribute("phrase", phrase);
      docOpsNewTagInfo.setAttribute("addAfterTag", addAfterTag);
      docOpsNewTagInfo.setAttribute("sectionId", sectionId);
      docOpsNewTagInfo.setAttribute("containerId", containerId);
      docOpsNewTagInfo.setAttribute("noteType", "textSelection");
      docOpsNewTagInfo.setAttribute("positionInSection", positionInSection);
    }
  };
  const getSelectionHtml = () => {
    let htmlString = "";
    let sel = window.getSelection();
    if (sel.rangeCount) {
      let container = document.createElement("div");
      container.appendChild(sel.getRangeAt(0).cloneContents());
      htmlString = container.innerHTML;
    }
    return htmlString;
  };

  const getSelectedText = () => {
    if (window.getSelection) {
      return window.getSelection().toString();
    } else if (document.selection()) {
      return document.selection.createRange().text;
    }
    return "";
  };

  const hasEndTags = (text) => {
    let isIncluded =
      text.includes("</section>") ||
      text.includes("</p>") ||
      text.includes("</div>") ||
      text.includes("</h1>") ||
      text.includes("</h2>") ||
      text.includes("</h3>") ||
      text.includes("</h4>") ||
      text.includes("</h5>") ||
      text.includes("</h6>");
    return isIncluded;
  };
  // ----------------- end of Add TextSelection  ------------------

  // ----------------- start of Finding NoteId  ------------------

  const findLastNoteId = (sectionId, elementId, positionInSection, type) => {
    let sectionElement = document.querySelector(`section#${CSS.escape(sectionId)}`);
    let allChildsInOrder = sectionElement.getElementsByTagName("*");
    let addAfter;
    if (type == "textSelection") {
      addAfter = findAddAfterForTextSelection(allChildsInOrder, elementId, positionInSection);
    } else if (type == "starNote") {
      addAfter = findAddAfterForStarNotes(allChildsInOrder, elementId);
    }
    return addAfter;
  };

  const findAddAfterForTextSelection = (allChildsInOrder, paragraphId, positionInSection) => {
    let sectionTagsArray = [];
    let result = null;

    for (let j = 0; j < allChildsInOrder.length; j++) {
      let element = allChildsInOrder[j];
      if (IsNodeChangesSummary(element)) continue;

      if (element.nodeName == "BUTTON") {
        if (element.classList.contains("removeNote")) {
          let buttonNoteId = element.getAttribute("noteid");
          sectionTagsArray.push(buttonNoteId);
        }
      } else if (element.nodeName == "SPAN") {
        if (element.hasAttribute("data-kw-noteid")) {
          let [lastNoteIdInSpan, spanStartPosition, spanFinishPosition] = findLastNoteIdInSpan(
            element,
            Infinity,
            Infinity
          );
          sectionTagsArray.push(lastNoteIdInSpan);
        }
      } else if (element.nodeName == "P") {
        let elementId = element.getAttribute("id");

        if (paragraphId == elementId) {
          let SpansInParagraph = element.getElementsByTagName("span");
          let newNotePosition = positionInSection.split("__");
          let newNoteStartPosition = parseFloat(newNotePosition[0]);
          let newNoteFinishPosition = parseFloat(newNotePosition[1]);
          for (let i = 0; i < SpansInParagraph.length; i++) {
            let spanElement = SpansInParagraph[i];
            let [lastNoteIdInSpan, spanStartPosition, spanFinishPosition] = findLastNoteIdInSpan(
              spanElement,
              newNoteStartPosition,
              newNoteFinishPosition
            );
            if (
              newNoteFinishPosition > spanFinishPosition ||
              (newNoteFinishPosition == spanFinishPosition && newNoteStartPosition > spanStartPosition)
            ) {
              sectionTagsArray.push(lastNoteIdInSpan);
            }
          }
          if (sectionTagsArray[0]) {
            const length = sectionTagsArray.length;
            result = sectionTagsArray[length - 1];
          }
        }
      }
    }

    return result;
  };

  const findAddAfterForStarNotes = (allChildsInOrder, buttonId) => {
    let sectionTagsArray = [];
    let result = null;

    for (let j = 0; j < allChildsInOrder.length; j++) {
      let element = allChildsInOrder[j];

      if (element.nodeName == "BUTTON") {
        let elementId = element.getAttribute("id");

        if (buttonId == elementId) {
          if (sectionTagsArray[0]) {
            const length = sectionTagsArray.length;
            result = sectionTagsArray[length - 1];
          }
        }
        if (element.classList.contains("removeNote")) {
          let buttonNoteId = element.getAttribute("noteid");
          sectionTagsArray.push(buttonNoteId);
        }
      } else if (element.nodeName == "SPAN") {
        if (element.hasAttribute("data-kw-noteid")) {
          let [lastNoteIdInSpan, spanStartPosition, spanFinishPosition] = findLastNoteIdInSpan(
            element,
            Infinity,
            Infinity
          );
          sectionTagsArray.push(lastNoteIdInSpan);
        }
      }
    }
    return result;
  };

  const findLastNoteIdInSpan = (span, newNoteStartPosition, newNoteFinishPosition) => {
    let spanNoteIds = span.getAttribute("data-kw-noteid").split(" ");
    let spanPositions = span.getAttribute("data-kw-position").split(" ");
    let spanNotePosition1 = spanPositions[0].split("__");
    let spanNoteStartPosition1 = parseFloat(spanNotePosition1[0]);
    let spanNoteFinishPosition1 = parseFloat(spanNotePosition1[1]);
    let lastNoteStartPosition;
    let lastNoteFinishPosition;
    let lastNoteId;
    const checkPositions = (firstStartPosition, firstFinishPosition, secondStartPosition, secondFinishPosition) => {
      if (firstFinishPosition > secondFinishPosition) {
        return true;
      } else if (firstFinishPosition == secondFinishPosition && firstStartPosition > secondStartPosition) {
        return true;
      } else {
        return false;
      }
    };
    let checkPosition1 = checkPositions(
      newNoteStartPosition,
      newNoteFinishPosition,
      spanNoteStartPosition1,
      spanNoteFinishPosition1
    );
    if (checkPosition1) {
      lastNoteId = spanNoteIds[0];
      lastNoteStartPosition = spanNoteStartPosition1;
      lastNoteFinishPosition = spanNoteFinishPosition1;
    }
    if (spanNoteIds.length != 1) {
      let spanNotePosition2 = spanPositions[1].split("__");
      let spanNoteStartPosition2 = parseFloat(spanNotePosition2[0]);
      let spanNoteFinishPosition2 = parseFloat(spanNotePosition2[1]);
      let checkPosition2 = checkPositions(
        newNoteStartPosition,
        newNoteFinishPosition,
        spanNoteStartPosition2,
        spanNoteFinishPosition2
      );
      if (
        spanNoteFinishPosition2 > spanNoteFinishPosition1 ||
        (spanNoteFinishPosition2 == spanNoteFinishPosition1 && spanNoteStartPosition2 > spanNoteStartPosition1)
      ) {
        if (checkPosition2) {
          lastNoteId = spanNoteIds[1];
          lastNoteStartPosition = spanNoteStartPosition2;
          lastNoteFinishPosition = spanNoteFinishPosition2;
        }
      } else {
        if (checkPosition1) {
          lastNoteId = spanNoteIds[0];
          lastNoteStartPosition = spanNoteStartPosition1;
          lastNoteFinishPosition = spanNoteFinishPosition1;
        }
      }
      if (spanNoteIds.length == 3) {
        let spanNotePosition3 = spanPositions[2].split("__");
        let spanNoteStartPosition3 = parseFloat(spanNotePosition3[0]);
        let spanNoteFinishPosition3 = parseFloat(spanNotePosition3[1]);
        let checkPosition3 = checkPositions(
          newNoteStartPosition,
          newNoteFinishPosition,
          spanNoteStartPosition3,
          spanNoteFinishPosition3
        );
        if (
          spanNoteFinishPosition3 > lastNoteFinishPosition ||
          (spanNoteFinishPosition3 == lastNoteFinishPosition && spanNoteStartPosition3 > lastNoteStartPosition)
        ) {
          if (checkPosition3) {
            lastNoteId = spanNoteIds[2];
            lastNoteStartPosition = spanNoteStartPosition3;
            lastNoteFinishPosition = spanNoteFinishPosition3;
          }
        }
      }
    }
    return [lastNoteId, lastNoteStartPosition, lastNoteFinishPosition];
  };

  const findAddAfterTag = (lastNoteId, sectionId) => {
    let result;
    if (!lastNoteId) {
      result = sectionId;
    } else {
      wordTagsArray.forEach((obj) => {
        if (obj.noteId == lastNoteId && obj.sectionId == sectionId) {
          result = obj.tag;
        }
      });
    }
    return result;
  };

  const reNumberingNotesForAddNote = (
    type,
    tag,
    title,
    sectionId,
    containerId,
    newNoteIdResult,
    positionInSection,
    addAfterTag
  ) => {
    return new Promise(async function (resolve, reject) {
      let wordReNumberingArray = [];
      let tagsReNumberingArray = [];
      let injectingIndex;
      for (let i = 0; i < wordTagsArray.length; i++) {
        const element = wordTagsArray[i];
        if (element.tag == addAfterTag) {
          injectingIndex = i + 1;
        }
        if (element.sectionId == sectionId) {
          newNoteIdResult.NoteIdMapping.forEach((changeElement) => {
            if (element.noteId == changeElement.FromId) {
              tagsReNumberingArray.push({ index: i, newNoteId: changeElement.ToId });
              wordReNumberingArray.push({ tag: element.tag, newNoteIdNumber: changeElement.DisplayToId });
            }
          });
        }
      }

      wordAPI
        .reNumberingNoteIds(wordReNumberingArray)
        .then(() => {
          tagsReNumberingArray.forEach((elem) => {
            wordTagsArray[elem.index].noteId = elem.newNoteId;
            setWordTagsArray(wordTagsArray);
          });

          let newWordTag = {};
          newWordTag.type = type;
          newWordTag.tag = tag;
          newWordTag.title = title;
          newWordTag.sectionId = sectionId;
          newWordTag.containerId = containerId;
          newWordTag.noteId = newNoteIdResult.NewId;
          newWordTag.isPersisted = false;

          if (type == "textSelection") {
            let Position = positionInSection.split("__");
            let startPosition = parseFloat(Position[0]);
            let finishPosition = parseFloat(Position[1]);
            newWordTag.startPosition = startPosition;
            newWordTag.endPosition = finishPosition;
          }

          if (injectingIndex) {
            wordTagsArray.splice(injectingIndex, 0, newWordTag);
            setWordTagsArray(wordTagsArray);
          } else {
            wordTagsArray.push(newWordTag);
            // setWordTagsArray((wordTagsArray) => [...wordTagsArray, newWordTag]);
          }
          resolve();
        })
        .catch(() => reject());
    });
  };

  const reNumberingNotesForRemoveNote = (tag, sectionId, noteIdResponse) => {
    return new Promise(async function (resolve, reject) {
      let wordTagsArrayLength = wordTagsArray.length;
      let wordReNumberingArray = [];
      let tagsReNumberingArray = [];
      let removeTagIndex;
      for (let i = 0; i < wordTagsArrayLength; i++) {
        const element = wordTagsArray[i];
        if (element.tag == tag) {
          removeTagIndex = i;
        }
        if (element.sectionId == sectionId) {
          noteIdResponse.NoteIdMapping.forEach((changeElement) => {
            if (element.noteId == changeElement.FromId) {
              tagsReNumberingArray.push({ index: i, newNoteId: changeElement.ToId });
              wordReNumberingArray.push({ tag: element.tag, newNoteIdNumber: changeElement.DisplayToId });
            }
          });
        }
      }
      await wordAPI
        .reNumberingNoteIds(wordReNumberingArray)
        .then(() => {
          tagsReNumberingArray.forEach((elem) => {
            wordTagsArray[elem.index].noteId = elem.newNoteId;
            setWordTagsArray(wordTagsArray);
          });
          wordTagsArray.splice(removeTagIndex, 1);
          setWordTagsArray(wordTagsArray);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };

  // ----------------- End of Finding NoteId  ------------------

  //------------------ Start of remove published note ------------------

  const removePublishedNote = () => {
    let button = document.querySelector("#removeModalButton");
    const tag = button.getAttribute("tag");
    const sectionId = button.getAttribute("sectionId");
    const containerId = button.getAttribute("containerId");
    const noteId = button.getAttribute("noteId");
    removeNote(tag, sectionId, containerId, noteId);
  };

  // ----------------- End of remove published note  ------------------

  //------------------ Start of docOps Mode ------------------

  const docOpsAddNoteButtonClicked = () => {
    let docOpsNewTagInfo = document.querySelector(".newTagInfoDocOpsMode");
    const tag = docOpsNewTagInfo.getAttribute("tag");
    const title = docOpsNewTagInfo.getAttribute("title");
    const phrase = docOpsNewTagInfo.getAttribute("phrase");
    const addAfterTag = docOpsNewTagInfo.getAttribute("addAfterTag");
    const sectionId = docOpsNewTagInfo.getAttribute("sectionId");
    const containerId = docOpsNewTagInfo.getAttribute("containerId");
    const noteType = docOpsNewTagInfo.getAttribute("noteType");
    let positionInSection = "";
    if (noteType == "textSelection") {
      positionInSection = docOpsNewTagInfo.getAttribute("positionInSection");
    }

    let inputNodeId = document.querySelector(".docOpsModalInput").value;
    APICalls.validateNewNoteIdDocOpsMode(containerId, inputNodeId, userInfoObject, workItemObject, decodedTokenObject)
      .then((result) => {
        if (result.IsExisting == true) {
          handleActionOfMessageBox("startAddingNote");
          hideModalElements();
          wordAPI
            .addNoteFunc(tag, title, phrase, addAfterTag, sectionId, inputNodeId)
            .then(() => {
              let newWordTag = {};
              newWordTag.type = noteType;
              newWordTag.tag = tag;
              newWordTag.title = title;
              newWordTag.sectionId = sectionId;
              newWordTag.containerId = containerId;
              newWordTag.noteId = "n" + inputNodeId;
              newWordTag.isPersisted = true;

              if (noteType == "textSelection") {
                const Position = positionInSection.split("__");
                const startPosition = parseFloat(Position[0]);
                const finishPosition = parseFloat(Position[1]);
                newWordTag.startPosition = startPosition;
                newWordTag.endPosition = finishPosition;
              }

              const wordTagsArrayLength = wordTagsArray.length;
              let injectingIndex = wordTagsArrayLength;
              for (let i = 0; i < wordTagsArrayLength; i++) {
                const element = wordTagsArray[i];
                if (element.tag == addAfterTag) {
                  injectingIndex = i + 1;
                }
              }
              if (injectingIndex != wordTagsArrayLength) {
                wordTagsArray.splice(injectingIndex, 0, newWordTag);
                setWordTagsArray(wordTagsArray);
              } else {
                wordTagsArray.push(newWordTag);
                // setWordTagsArray((wordTagsArray) => [...wordTagsArray, newWordTag]);
              }
              document.querySelector(".docOpsModalInput").value = "";
              load().then(() => {
                sendLog("INFO", "Add note", "DopOps mode", tag);
                sendMetric("AddNote", "DopOps mode", "Success", tag);
                handleActionOfMessageBox("successAddingNote");
              });
            })
            .catch(() => {
              console.log("problem with adding notes to word", err);
              sendLog("ERROR", "Add note", "DopOps mode", tag + "   problem with adding notes to word");
              handleActionOfErrorBox("addingNoteFail");
            });
        } else {
          document.querySelector(".docOpsNoteIdError").style.display = "block";
          setTimeout(() => {
            document.querySelector(".docOpsNoteIdError").style.display = "";
          }, 4000);
        }
      })
      .catch(() => {
        document.querySelector(".docOpsNoteIdError").style.display = "block";
        setTimeout(() => {
          document.querySelector(".docOpsNoteIdError").style.display = "";
        }, 4000);
      });
  };

  const reloadAfterDeactivatingDocOpsMode = async () => {
    const docOpsMode = document.querySelector("#lawTab").classList.contains("docOpsMode");
    if (docOpsMode) {
      isNoteIdApiInitiated = false;
      // setIsNoteIdApiInitiated(isNoteIdApiInitiated);
      load().then(() => initiatingNoteId());
    }
  };

  //------------------ End of docOps Mode --------------------

  //------------------  Start of error and message box --------

  const handleActionOfMessageBox = (type) => {
    setMessageBoxProp("hideMessageBox");
    setErrorBoxProp("hideErrorBox");
    setMessageBoxProp(type);
  };

  const handleActionOfErrorBox = (type) => {
    setErrorBoxProp("hideErrorBox");
    setMessageBoxProp("hideMessageBox");
    setErrorBoxProp(type);
  };

  //------------------  End of error and message box --------

  //------------------  Start of log & Metrics --------

  const sendLog = (level, message, method, params) => {
    APICalls.log(level, message, method, params, workItemObject, userInfoObject, decodedTokenObject);
  };

  const sendMetric = (category, subCategory, status, tag, message) => {
    APICalls.logMetric(category, subCategory, status, tag, message, workItemObject, userInfoObject, decodedTokenObject);
  };

  //------------------  End of log & Metrics --------

  return (
    <div className="lawPage">
      {workItemObject?.IsAuthorValidated && (
        <div className="isAuthorValidated">
          <p>Er hovedajourhold.</p>
          <hr></hr>
        </div>
      )}

      <div id="lovtekst"></div>

      {/* Modal for removing published notes */}
      <div className="removeModal alert alert-info alert-dismissible fade show">
        <div>
          <p className="removeModalMessage">Noten er allerede publisert. Er du sikker på at den skal slettes?</p>
        </div>
        <button type="button" className="btn-close" onClick={hideModalElements}></button>
        <div className="buttonBox">
          <button className="modalButton" id="removeModalButton" onClick={removePublishedNote}>
            Slett
          </button>
          <button className="modalButton" onClick={hideModalElements}>
            Avbryt
          </button>
        </div>
      </div>

      {/* Modal for DocOpsMode */}
      <div className="docOpsModal alert alert-info alert-dismissible fade show">
        <div>
          <p>
            <i className="ms-Icon ms-Icon--CodeEdit"></i> <em>Sett NoteId</em>
          </p>
          <button type="button" className="btn-close" onClick={hideModalElements}></button>
        </div>
        <p>Tast inn note nummer manuelt</p>
        <div className="newTagInfoDocOpsMode"></div>
        <div className="buttonBox">
          <input type="text" placeholder="note Id" className="docOpsModalInput" />
          <button className="modalButton" id="docOpsModalButton" onClick={docOpsAddNoteButtonClicked}>
            Ok
          </button>
          <button className="modalButton" onClick={hideModalElements}>
            Avbryt
          </button>
          <p className="docOpsNoteIdError">Note id er ikke gyldig. Prøv igjen</p>
        </div>
      </div>

      {/* add and remove buttons */}
      <div id="textSelectionRemove1" className="textSelectionButton removeTextSelectionButton">
        <img src={minusyellow} />
      </div>
      <div id="textSelectionRemove2" className="textSelectionButton removeTextSelectionButton">
        <img src={minusblue} />
      </div>
      <div id="textSelectionRemove3" className="textSelectionButton removeTextSelectionButton">
        <img src={minusgrey} />
      </div>
      <div id="textSelectionAdd1" className="textSelectionButton addTextSelectionButton">
        <img src={plusyellow} />
      </div>
      <div id="textSelectionAdd2" className="textSelectionButton addTextSelectionButton">
        <img src={plusblue} />
      </div>
      <div id="textSelectionAdd3" className="textSelectionButton addTextSelectionButton">
        <img src={plusgrey} />
      </div>
    </div>
  );
}
